import { render, staticRenderFns } from "./steps-new.vue?vue&type=template&id=71bccb82&"
import script from "./steps-new.vue?vue&type=script&lang=js&"
export * from "./steps-new.vue?vue&type=script&lang=js&"
import style0 from "./steps-new.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports